import React, { useState, useEffect } from "react";
import {
  Button,
} from "reactstrap";
import PropTypes from "prop-types";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';




const OverButton = (props) => {
  // console.log(props);
  return (

    <OverlayTrigger
      placement='bottom-end'
      overlay={
        <Tooltip id="tooltip-disabled">
          <strong style={{ fontSize: 15 }}>{props.label}</strong>
        </Tooltip>
      }
    >
      {/* title={props.label} */}
      <Button
        className="ms-0 me-1 mt-0 text-center btn-sm"
        // btn-rounded
        onClick={() =>
          props.onClick()
        }
        color={props.color}
      >
        <i className={props.icon}></i>
        {/* &nbsp;  */}
      </Button>
    </OverlayTrigger>
  )
}

OverButton.propTypes = {
  onClick: PropTypes.any,
  color: PropTypes.any,
  icon: PropTypes.any,
  label: PropTypes.any,
};

export default OverButton;